(ns common.schema.entities.reminder-rule.core
  (:require
   [common.schema.entities.reminder-rule.permissions :as permissions]
   [common.schema.entities.reminder-rule.schema :as schema]))

(def entity-type-definition
  {:entity-type                  :entity.type/reminder-rule
   :schema                       schema/schema
   :name                         {:en "Reminder rule"}
   :plural                       {:en "Reminder rules"}
   :icon                         :fa-bell
   :display-name-template        "{{reminder-rule/rule-label}}"
   :display-name/depends-on      [:reminder-rule/rule-label]
   :permissions                  {:creatable?   true
                                  :disableable? true}
   :read-permissions-check-fn    permissions/read-permissions?
   :disable-permissions-check-fn permissions/disable-permissions?})
